// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"89":"license","443":"about"}[chunkId] + "-legacy." + {"89":"6914f8c8","443":"8173789d"}[chunkId] + ".js";
};